import React from "react";
import {compose} from "redux";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {Image, ScrollView, StyleSheet, Text, TouchableOpacity, View, Modal, Button} from "react-native";

import CheckNotActivePicto from "../Picto/CheckNotActivePicto";
import CheckActivePicto from "../Picto/CheckActivePicto";
import ChevronDroitMediumPicto from "../Picto/ChevronDroitMediumPicto";
import ChevronBasPicto from "../Picto/ChevronBasPicto";

import {ActivityIndicator} from "react-native";

import { fetch_api_json } from "../../API/API";
import { sw_api } from "../../sw/helpers";
import { getSwRegistration } from "../../sw/sw_registration";
import { subscribe, unsubscribe } from "../../sw/sw_subscribe";

function getServiceWorkerInfos() {
  const reg = getSwRegistration();
  if (! reg) {
    return Promise.reject("No service worker");
  }
  return reg.pushManager.getSubscription().then(sub => {
    return {registration: reg, subscription: sub};
  })
}

class ReglageNotifScreen extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
          modal: false,
          version: null,
          registration: null,
          subscription: null,
          permission: null,
          pong_pending: false,
          sub_pending: false,
          show_advanced: false
        }

      this.getVersion();
      this.registrationInfo();

      this.getVersion = this.getVersion.bind(this);
      this.toggleSubscribe = this.toggleSubscribe.bind(this);
      this.registrationInfo = this.registrationInfo.bind(this);
      this.requestNotificationPermission = this.requestNotificationPermission.bind(this);
      this.requestPermissionAndMaySubscribe = this.requestPermissionAndMaySubscribe.bind(this);
      this.reload = this.reload.bind(this);
      this.ping = this.ping.bind(this);
    }

    componentDidMount() {
      this._setHeader();
    }

    componentDidUpdate() {
      this._setHeader();
    }

    registrationInfo() {
      getServiceWorkerInfos().then(({registration, subscription}) => {
	console.log(registration);
	console.log(subscription);
        this.setState(() => {
	  console.log("in registration info 3");

          return {registration, subscription};
        });
      }).catch((error) => {
	console.log("RegistrationInfo error:", error);
      })
    }


    requestNotificationPermission() {
      const {t} = this.props;

      return Notification.requestPermission((permission) => {
	// If the user accepts, let's create a notification
        this.setState({permission})

	if (permission === "granted") {
	  new Notification(t("Notification activated"));
	  return true;
	}
	return false;
      });
    }

    requestPermissionAndMaySubscribe() {
      if (Notification.permission == "granted") {
	this.toggleSubscribe()
      } else {
	this.requestNotificationPermission().then((granted) => {
	  return this.toggleSubscribe();
	})
      }
    }


    wrapInModal(cb, type) {
      return () => {
        this.setState({ modal: {cb, type} })
      }
    }

    closeModal() {
      this.setState({ modal: null })
    }

    getVersion() {
      sw_api.getVersion().then(x => {
        const { version, time_installed, time_activated } = x.payload
        console.log("VERSION: " + version);
        this.setState(() => ({ version: { version } }));
      })
    }

    toggleSubscribe() {
      const {registration, subscription} = this.state
      this.setState({sub_pending: true});

      let promise;
      if (subscription) {
	promise = unsubscribe(registration)
      } else {
	promise = subscribe(registration)
      }
      promise.then(() => {
	this.setState({sub_pending: false});
	this.registrationInfo();
      });
    }

    reload() {
      window.location.reload();
    }

    _setHeader(){
        const styleHeaderGlobalWhite = {
            fontFamily: this.props.theme.fonts.title,
            backgroundColor : this.props.theme.colors.primary.White.value,
            height:80
        }  ;
        this.props.navigation.setOptions(
            {
                headerTitleAlign: "center",
                headerStyle: styleHeaderGlobalWhite,
                headerTitleStyle:{textTransform: 'capitalize'},
                title : this.props.t('Notification'),
                headerLeft : ()=><TouchableOpacity onPress={this.props.navigation.goBack}>
                    <Image resizeMode={"contain"} style={{width:20,height: 20,marginLeft:20, flex: 1}} source={this.props.theme.pictos.chevronGaucheMediumPicto.light} />
                </TouchableOpacity>
            }
        );
    }

    ping(endpoint) {
      if (! endpoint) { return; }

      const {t} = this.props;
      this.setState({ pong_pending: true })

      const params = { body: JSON.stringify({endpoint}) }

      fetch_api_json("post", "/notification/ping", params).then((results) => {
        this.setState({ pong_pending: false })

	let txt;
	const result_for_endpoint = results.find(res => res.endpoint == endpoint);

	console.log(result_for_endpoint);
	if (result_for_endpoint == null) {
	  txt = t("Not found")
	} else {
	  txt = {
	    "sent": t("sent"),
	    "deleted": t("deleted"),
	    "error": t("error"),
	  }[result_for_endpoint.result]
	}

	alert(txt)
      }).catch((err) => {
        console.log(err);
        alert("An error occured")
      })
    }

    render() {
	const {t} = this.props;

        const styles= StyleSheet.create({
            container:{
                paddingVertical:12,
                paddingHorizontal:20,
                flexDirection:"row",
                justifyContent:"space-between",
                alignItems:"center",
                borderBottomWidth:1,
                borderBottomColor:this.props.theme.colors.tertiary.black13.value,
                backgroundColor:this.props.theme.colors.primary.White.value
            },
            container2:{
                backgroundColor:"red",
                justifyContent:"flex-end",
            },
            modal:{
                justifyContent:"flex-end",
            },
            container_title:{
                backgroundColor:this.props.theme.colors.primary.blue5.value,
                color:this.props.theme.colors.primary.blue1.value
            },
            text:{
                fontFamily:this.props.theme.fonts.text_bold,
                color : this.props.theme.colors.tertiary.black3.value,
                fontSize:15,
                fontWeight:500
            },
            text_title:{
                color:this.props.theme.colors.primary.blue1.value
            },
            text_value: {
              color: this.props.theme.colors.secondary.orange1.value,
	      paddingLeft: 5
            },
            picto:{
                width:10,
                marginRight:10
            }
        });

        const {version, modal, registration, subscription, show_advanced, sub_pending} = this.state;

        const getModal = () => {
          return <Modal style={styles.modal} transparent={true} animationType={'slide'} visible={true} onRequestClose={this.closeModal}>
            <View style={styles.view}>
                <View>
                    <Text>{ modal.title }</Text>
                    <TouchableOpacity onPress={this.closeModal}>
                        {/* <FermerPicto style={{width:15,height:15}} isHeader={true} /> */}
                        <Button title={"Annuler"} onPress={this.closeModal} />
                    </TouchableOpacity>
                    <TouchableOpacity onPress={()=>{this.props.setModalVisible(!this.props.modalVisible)}} >
                        <Button title={"Confirmer"} onPress={modal.cb} />
                    </TouchableOpacity>
                </View>
              </View>
          </Modal>
        }


        /* this.wrapInModal(this.fillCache, 'fillcache') */
        return (
          <View>
            { /* modal && getModal() */ }
            <ScrollView>
                <TouchableOpacity onPress={this.requestPermissionAndMaySubscribe}>
                    <View style={styles.container}>
                        <Text style={styles.text}>
			  {subscription ? t("Deactivate subscription") : t("Activate subscription and notification")}
			</Text>
                        <View>
                          {
			   sub_pending
			   ? <ActivityIndicator size='large' color="#000" />
			   : (
			     subscription
			     ? <CheckActivePicto isHeader={true} style={{width:26,height:26}} />
			     : <CheckNotActivePicto isHeader={true} style={{width:26,height:26}} />
			   )
                          }
                        </View>
                    </View>
                </TouchableOpacity>

                <TouchableOpacity onPress={() => this.setState({show_advanced: !show_advanced})}>
                    <View style={styles.container}>
                        <Text style={styles.text}>
			  { t("Advanced parameters") }
			</Text>
                        <View>
                          {
                           show_advanced
                           ? <ChevronBasPicto isHeader={true} style={{width:18}} />
                           : <ChevronDroitMediumPicto isHeader={true} style={{width:10}} />
                          }
                        </View>
                    </View>
                </TouchableOpacity>

		{
		show_advanced &&
		<View style={{}}>
		  <View style={[styles.container,styles.container_title]}>
		      <Text style={[styles.text,styles.text_title]}>{t("App version")}</Text>
		      <Text style={styles.text_value}>{ __COMMIT_HASH__ }</Text>
		  </View>

		  <View style={styles.container}>
		      <Text style={styles.text}>{t("Notification display")}</Text>
		      <Text style={styles.text_value}>
			{
			  {
			    granted: t("Granted"),
			    denied: t("Denied"),
			    default: t("Unset (will be denied)")
			  }[Notification.permission]
			}
		      </Text>
		  </View>

		  <View style={styles.container}>
		      <Text style={styles.text}>{t("Subscription info")}</Text>
		      <Text style={styles.text_value}>
			{ subscription && subscription.endpoint || t("No subscription") }
		      </Text>
		  </View>

		  {
		  (subscription && subscription.endpoint) &&
		  <TouchableOpacity onPress={() => this.ping(subscription.endpoint)}>
		      <View style={styles.container}>
			  <Text style={styles.text}>
			    { t("Ping") }
			  </Text>
			  <View>
			    {
			     this.state.pong_pending
			     ?  <ActivityIndicator size='large' color="#000" />
			     : <CheckActivePicto isHeader={true} style={{width:26,height:26}} />
			    }
			  </View>
		      </View>
		  </TouchableOpacity>
		  }

		  <TouchableOpacity onPress={this.reload}>
		      <View style={styles.container}>
			  <Text style={styles.text}>{t("Reload app")}</Text>
			  <View>
			    <CheckActivePicto isHeader={true} style={{width:26,height:26}} />
			  </View>
		      </View>
		  </TouchableOpacity>
		</View>
		}
            </ScrollView>
          </View>
        );
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default compose(connect(mapStateToProps),withTranslation())(ReglageNotifScreen);
